var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTheatre(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg453",
    xmlSpace: "preserve",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs457"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath467"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path465"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g459",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g463",
    clipPath: "url(#clipPath467)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g469",
    transform: "translate(76.126,345.7051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -4.045,1.722 C -35.692,15.193 -70.528,-9.089 -68.84,-43.442 l 6.321,-122.648 c 2.958,-60.218 32.889,-115.899 81.483,-151.586 v -0.001 c 37.295,-27.389 88.056,-27.389 125.349,0 l 0.001,0.001 c 18.623,13.676 34.492,30.297 47.165,48.976",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path471"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g473",
    transform: "translate(283.7656,105.624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 10.603,23.004 16.885,48.074 18.158,73.991 l 6.321,122.648 c 1.687,34.353 -33.148,58.635 -64.795,45.164 l -50.642,-21.556 c -22.39,-9.531 -47.695,-9.531 -70.085,0 l -16.763,7.135",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path475"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g477",
    transform: "translate(223.7002,122.167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 0 c 3.208,1.797 6.558,-2.124 4.281,-5.011 l -21.936,-27.838 c -24.612,-31.23 -71.949,-31.23 -96.56,0 l -21.936,27.838 c -2.277,2.887 1.073,6.808 4.28,5.011 h 0.001 C -90.907,-22.941 -40.963,-22.941 0,0 Z",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path479"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g481",
    transform: "translate(489.627,278.1714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 4.813,15.708 7.728,32.096 8.55,48.837 l 6.321,128.648 c 1.688,34.353 -33.148,58.635 -64.796,45.164 l -50.641,-21.556 c -22.39,-9.531 -47.696,-9.531 -70.084,0 l -50.643,21.556 c -31.646,13.471 -66.482,-10.811 -64.795,-45.164 l 4.169,-84.839",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path483"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g485",
    transform: "translate(329.9297,157.6602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 29.479,-6.878 61.268,-0.963 86.764,17.762 v 0 c 25.911,19.029 46.511,43.744 60.549,71.799",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path487"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g489",
    transform: "translate(335.4912,251.4966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 28.706,3.976 58.401,-1.318 84.463,-15.914 3.208,-1.796 6.557,2.124 4.281,5.012 L 66.807,16.935 C 50.664,37.42 24.743,44.467 1.871,38.079",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path491"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g493",
    transform: "translate(48.875,288.707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 20.632,11.905 43.9,11.905 69.806,0",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path495"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g497",
    transform: "translate(106.0137,218.8896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -16.367,4.842 -31.046,4.491 -44.472,0.279 -3.908,-1.226 -7.872,1.75 -7.872,5.846 v 9.937 c 0,16.557 13.251,30.286 29.808,30.388 0.2,10e-4 0.401,10e-4 0.601,0 C -5.378,46.348 7.873,32.619 7.873,16.062 V 5.844 C 7.873,1.749 3.927,-1.162 0,0 Z",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path499"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g501",
    transform: "translate(263.8965,288.707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -20.632,11.905 -43.9,11.905 -69.806,0",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path503"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g505",
    transform: "translate(206.7588,218.8896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 16.366,4.842 31.046,4.491 44.471,0.279 3.908,-1.226 7.873,1.75 7.873,5.846 v 9.937 c 0,16.557 -13.252,30.286 -29.808,30.388 -0.201,10e-4 -0.401,10e-4 -0.602,0 -16.556,-0.102 -29.808,-13.831 -29.808,-30.388 v -10.218 c 0,-4.095 3.945,-7.007 7.873,-5.846 z",
    style: {
      fill: "none",
      stroke: "white",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path507"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheatre);
export default __webpack_public_path__ + "static/media/theatre.559675bffe7f594034ede8f65cb1a963.svg";
export { ForwardRef as ReactComponent };